// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + (chunkId === 725 ? "dh-basis-kart" : chunkId) + "-chunk-" + {"222":"66619478266368cf820e","725":"212e1be4407cd766a826"}[chunkId] + ".js";
};